module.exports = __webpack_public_path__ + "static/img/FM.5ab3d1e7.svg";